import { render, staticRenderFns } from "./SimpleFooter.vue?vue&type=template&id=0ae80256&scoped=true&"
import script from "./SimpleFooter.vue?vue&type=script&lang=ts&"
export * from "./SimpleFooter.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.scss?vue&type=style&index=0&id=0ae80256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae80256",
  null
  
)

export default component.exports